import AdsEntitiesFactory from '../../ads/Entities/factory.js'
import DealerEntitiesFactory from '../../dealer/Entities/factory.js'
import DealerMappersFactory from '../../dealer/Mappers/factory.js'
import PageServicesFactory from '../../page/Services/factory.js'
import UserValueObjectsFactory from '../ValueObjects/factory.js'
import HTTPUserFavoritesResponseMapper from './HTTPUserFavoritesResponseMapper.js'
import UserFavoriteContractRawDataMapper from './UserFavoriteContractRawDataMapper.js'
import UserFavoriteRawDataToUserFavoriteEntityMapper from './UserFavoriteRawDataToUserFavoriteEntityMapper.js'

export default class UserFavoritesMappersFactory {
  static userFavoriteRawDataToUserFavoriteEntityMapper = ({config}) =>
    new UserFavoriteRawDataToUserFavoriteEntityMapper({
      config,
      entity: AdsEntitiesFactory.adEntity
    })

  static userFavoriteContractRawDataMapper = ({config}) =>
    new UserFavoriteContractRawDataMapper({
      config,
      entity: DealerEntitiesFactory.dealerEntity,
      locationMapper: DealerMappersFactory.fromDealerLocationJsonToLocationValueObjectMapper({config}),
      getUrlService: PageServicesFactory.getUrlService({config})
    })

  static hTTPUserFavoritesResponseMapper = ({config}) =>
    new HTTPUserFavoritesResponseMapper({
      adMapper: UserFavoritesMappersFactory.userFavoriteRawDataToUserFavoriteEntityMapper({config}),
      contractMapper: UserFavoritesMappersFactory.userFavoriteContractRawDataMapper({config}),
      valueObject: UserValueObjectsFactory.userFavoritesListValueObject
    })
}
